module.exports = __webpack_public_path__ + "img/shakeys_tray.54581057.jpg";